import './OliveIcon.css';

export const OliveIcon = () => {
  return (
    <div className="olive-container mr-3">
      <div className="olive-icon" aria-hidden="true" role="presentation"></div>
    </div>
  );
};

export const OliveIconWhite = () => {
  return (
    <div className="olive-container-white">
      <div className="olive-icon" aria-hidden="true" role="presentation"></div>
    </div>
  );
};

export const OliveIconSmall = () => {
  return (
    <div className="olive-container-sm">
      <div className="olive-icon" aria-hidden="true" role="presentation"></div>
      <span className="sr-only">Olive</span>
    </div>
  );
};
